import{isSymbol as o}from"../predicate/isSymbol.js";function m(r){return o(r)?NaN:Number(r)}export{m as toNumber};
